// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"85211b35","120":"b360e9d6","414":"e38fe96f","506":"af602a40","606":"98437955","608":"cf491aac","615":"57c3b27c","993":"0aed658d"}[chunkId] + ".chunk.js";
};